import React, { useEffect, useState } from "react"; // Importa React e hooks
import { Link } from 'react-router-dom';
import Imagens from "../../img/imagens";
import './comunicados.css'; // Estilos adicionais para comunicados

//const baseUrl = "https://localhost:44304/api"; // API de DEV (localhost)
const baseUrl = "http://10.80.12.5:81/api"; // API de Produção

// Componente principal para exibir comunicados
export default function Comunicados() {
  const [noticias, setNoticias] = useState([]); // Estado para armazenar as notícias
  const [imagemAberta, setImagemAberta] = useState(null); // Estado para imagem em destaque (modal)

  // Busca as notícias na API ao montar o componente
  useEffect(() => {
    fetch(`${baseUrl}/Noticia`)
      .then((res) => res.json())
      .then((data) => setNoticias(data.reverse().slice(0, 30))) // Pega os 30 comunicados mais recentes
      .catch((err) => console.error("Erro ao buscar notícias:", err));
  }, []);

  return (
    <div className="container mt-5">
      {/* Cabeçalho com logo e botão de voltar */}
      <header className="App-header d-flex justify-content-between align-items-center mb-4">
        <a href='https://www.prefeitura.sp.gov.br/cidade/secretarias/controladoria_geral/' target='blank' rel="noopener noreferrer" className='logolink'>
          <img src={Imagens.CGM1} alt="Prefeitura" width="150" className='logo' />
        </a>
        <div className='Voltar'>
          <Link className='voltarbtn d-flex align-items-center' to="/">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="bi bi-arrow-return-left" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5" />
            </svg>
            <p className="mb-0 ms-2">Voltar à tela inicial</p>
          </Link>
        </div>
      </header>

      {/* Título da página */}
      <h1 className="text-center mb-4" style={{ color: "#EC6608", marginTop: "100px", fontWeight: "bold", animation: "fadeIn 1s ease-in-out" }}>
        Comunicados
      </h1>

      {/* Grid de cards de comunicados */}
      <div className="row">
        {noticias.map((noticia, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div
              className="card h-100 shadow-sm comunicados-card"
              onClick={() => setImagemAberta(noticia.imagemBase64)}
            >
              <img
                src={noticia.imagemBase64.startsWith('data:image') ? noticia.imagemBase64 : `data:image/png;base64,${noticia.imagemBase64}`}
                alt={noticia.titulo}
                className="card-img-top"
                style={{ height: "200px", objectFit: "cover" }}
              />
              <div className="card-body">
                <h5 className="card-title text-truncate">{noticia.titulo}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de imagem fullscreen */}
      {imagemAberta && (
        <div
          className="modal d-flex align-items-center justify-content-center"
          style={{
            position: "fixed",
            top: 0, left: 0, width: "100%", height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 1050
          }}
          onClick={() => setImagemAberta(null)}
        >
          <img
            src={imagemAberta.startsWith('data:image') ? imagemAberta : `data:image/png;base64,${imagemAberta}`}
            alt="Imagem completa"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
      {/* Estilo para animação de fadeIn */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}
